<template>
    <layout>
        <template v-slot:title>{{ $t('Beach monitoring facility') }}</template>
        <center>
            <md-empty-state
                md-icon="devices_other"
                md-label="This page was not found"
                :md-description="description"
            >
                <md-button class="md-primary md-raised">Home</md-button>
            </md-empty-state>
        </center>
    </layout>
</template>

<script>
export default {
    data() {
        return {
            description: this.$t(
                'Go back to the home page to access all the amazing pages of beach monitoring'
            )
        }
    }
}
</script>
